<template lang="pug">
  span
    template(v-if="currency == 'USD'")
      i.flag-icon.flag-icon-us.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'THB'")
      i.flag-icon.flag-icon-th.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'IDR'")
      i.flag-icon.flag-icon-id.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'VND'")
      i.flag-icon.flag-icon-vn.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'CNY'")
      i.flag-icon.flag-icon-cn.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'HKD'")
      i.flag-icon.flag-icon-hk.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'SGD'")
      i.flag-icon.flag-icon-sg.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'KRW'")
      i.flag-icon.flag-icon-kr.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'AUD'")
      i.flag-icon.flag-icon-au.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'INR'")
      i.flag-icon.flag-icon-in.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'MMK'")
      i.flag-icon.flag-icon-mm.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'MMO'")
      i.flag-icon.flag-icon-mm.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'BDT'")
      i.flag-icon.flag-icon-bd.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'EUR'")
      i.flag-icon.flag-icon-eu.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'TND'")
      i.flag-icon.flag-icon-tn.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'ARS'")
      i.flag-icon.flag-icon-ar.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'BND'")
      i.flag-icon.flag-icon-bn.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'PKR'")
      i.flag-icon.flag-icon-pk.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'GOO'")
      i.flag-icon.flag-icon-go.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'UST'")
      i.flag-icon.flag-icon-usdt.mr-1
      span #[b USDT ]
    template(v-else-if="currency == 'LAK'")
      i.flag-icon.flag-icon-la.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'JPY'")
      i.flag-icon.flag-icon-jp.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'NPR'")
      i.flag-icon.flag-icon-np.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'BRL'")
      i.flag-icon.flag-icon-br.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'LKR'")
      i.flag-icon.flag-icon-lk.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'PHP'")
      i.flag-icon.flag-icon-ph.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'MNT'")
      i.flag-icon.flag-icon-mn.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'AED'")
      i.flag-icon.flag-icon-ae.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'CAD'")
      i.flag-icon.flag-icon-ca.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'CHF'")
      i.flag-icon.flag-icon-ch.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'COP'")
      i.flag-icon.flag-icon-co.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'DKK'")
      i.flag-icon.flag-icon-dk.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'GBP'")
      i.flag-icon.flag-icon-gb.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'KHR'")
      i.flag-icon.flag-icon-kh.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'MXN'")
      i.flag-icon.flag-icon-mx.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'NGN'")
      i.flag-icon.flag-icon-ng.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'NOK'")
      i.flag-icon.flag-icon-no.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'NZD'")
      i.flag-icon.flag-icon-nz.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'RUB'")
      i.flag-icon.flag-icon-ru.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'SEK'")
      i.flag-icon.flag-icon-se.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'TRY'")
      i.flag-icon.flag-icon-tr.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'ZAR'")
      i.flag-icon.flag-icon-za.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'PEN'")
      i.flag-icon.flag-icon-pe.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'KES'")
      i.flag-icon.flag-icon-ke.mr-1
      span #[b {{ currency }} ]
    template(v-else-if="currency == 'PGK'")
      i.flag-icon.flag-icon-pg.mr-1
      span #[b {{ currency }} ]
    template(v-else)
      i.flag-icon.flag-icon-my.mr-1
      span #[b {{ currency }} ]
</template>

<script>
export default {
  props: {
    currency: ""
  }
}
</script>
